export default "__VITE_ASSET__5d376834__"